import {
  animate,
  animateChild,
  query,
  sequence,
  stagger,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const wrapperIn = trigger('wrapperIn', [
  transition(':enter', [
    sequence([
      query('@bgInOut', animateChild()),
      query('@linksInOut', stagger(30, animateChild()), { optional: true }),
    ]),
  ]),
  transition(':leave', [
    sequence([
      query('@linksInOut', stagger(30, animateChild()), { optional: true }),
      query('@bgInOut', animateChild()),
    ]),
  ]),
]);

export const bgInOut = trigger('bgInOut', [
  transition(':enter', [
    style({ opacity: 0.9, transform: 'translateY(-100%)' }),
    animate(
      '300ms ease-in-out',
      style({ opacity: 1, transform: 'translateY(0%)' })
    ),
  ]),
  transition(':leave', [
    style({ opacity: 1 }),
    animate(
      '300ms ease',
      style({ opacity: 0.9, transform: 'translateY(-100%)' })
    ),
  ]),
]);

export const linksInOut = trigger('linksInOut', [
  transition(':enter', [
    style({ opacity: 0, transform: 'translateY(20px)' }),
    animate('300ms ease', style({ opacity: 1, transform: 'translateY(0)' })),
  ]),
  transition(':leave', [
    style({ opacity: 1, transform: 'translateY(0)' }),
    animate(
      '300ms ease',
      style({ opacity: 0, transform: 'translateY(-20px)' })
    ),
  ]),
]);
